import * as React from 'react';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';
import Sports from '@material-ui/icons/Sports';

interface Props {
	value?: number;
}

const TotalActiveCoachesCard = (props: Props) => {
	const { value } = props;
	const translate = useTranslate();
	return (
		<CardWithIcon
			to="/coaches"
			icon={Sports}
			title={translate('TOTAL_ACTIVE_COACHES')}
			subtitle={value || '---'}
		/>
	);
};

export default TotalActiveCoachesCard;
